import { ChevronLeft, ChevronRight } from 'lucide-react'

interface Props {
  currentPage: number // 1-based
  totalCount: number
  pageSize: number
  onPageChange: (page: number) => void
}

export default function PaginationControls({
  currentPage,
  totalCount,
  pageSize = parseInt(process.env.REACT_APP_PAGE_SIZE || '10', 10),
  onPageChange,
}: Props) {
  const totalPages = Math.ceil(totalCount / pageSize)

  const canGoBack = currentPage > 1
  const canGoForward = currentPage < totalPages

  const goToPrevious = () => {
    if (canGoBack) {
      onPageChange(currentPage - 1)
    }
  }

  const goToNext = () => {
    if (canGoForward) {
      onPageChange(currentPage + 1)
    }
  }

  if (totalCount === 0 || totalPages <= 1) {
    return null
  }

  return (
    
    <div className="flex items-center justify-between mt-4 gap-4">
      
      <button
        onClick={goToPrevious}
        disabled={!canGoBack}
        className="flex items-center gap-2 px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
      >
        <ChevronLeft size={18} />
      </button>

      <span className="text-sm">
        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
      </span>

      <button
        onClick={goToNext}
        disabled={!canGoForward}
        className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  )
}
